import {
  AUTOMOTIVE_GROUP_LANDING_CONFIG,
  DEVELOPMENT_WHATSAPP_URL,
} from '../config/automotiveGroupLanding';

const { META_PIXEL_ID, GA_MEASUREMENT_ID, WHATSAPP_GROUP_URL } =
  AUTOMOTIVE_GROUP_LANDING_CONFIG;

const META_PIXEL_INITIALIZED_KEY = '__ctMetaPixelInitialized';

const isConfigured = (value) =>
  typeof value === 'string' &&
  value.trim() !== '' &&
  !value.includes('[COLE AQUI');

const normalizeExternalUrl = (value) => {
  const normalized = value.trim().replace(/^\[|\]$/g, '').trim();

  try {
    const url = new URL(normalized);
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
};

const loadScript = (src, id) => {
  if (document.getElementById(id)) return;
  const script = document.createElement('script');
  script.id = id;
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};

const initializeMetaPixel = () => {
  if (!isConfigured(META_PIXEL_ID)) return false;

  if (!window.fbq) {
    const fbq = function (...args) {
      fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
    };
    window.fbq = fbq;
    window._fbq = window._fbq || fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    loadScript('https://connect.facebook.net/en_US/fbevents.js', 'meta-pixel-script');
  } else if (!window._fbq) {
    window._fbq = window.fbq;
  }

  if (!window[META_PIXEL_INITIALIZED_KEY]) {
    window.fbq('init', META_PIXEL_ID);
    window[META_PIXEL_INITIALIZED_KEY] = true;
  }

  return typeof window.fbq === 'function';
};

export function initializeLandingTracking() {
  if (initializeMetaPixel()) {
    window.fbq('track', 'PageView');
  }

  if (isConfigured(GA_MEASUREMENT_ID) && !document.getElementById('ga-script')) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    loadScript(
      `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`,
      'ga-script'
    );
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);
  }
}

export function trackWhatsAppGroupClick() {
  const eventParameters = {
    destination: 'whatsapp_group',
    page_type: 'automotive_group_landing_page',
  };

  if (isConfigured(META_PIXEL_ID) && typeof window.fbq === 'function') {
    window.fbq('trackCustom', 'WhatsAppGroupClick', eventParameters);
  }

  if (isConfigured(GA_MEASUREMENT_ID) && typeof window.gtag === 'function') {
    window.gtag('event', 'WhatsAppGroupClick', eventParameters);
  }
}

export function getWhatsAppGroupUrl() {
  if (!isConfigured(WHATSAPP_GROUP_URL)) return DEVELOPMENT_WHATSAPP_URL;
  return normalizeExternalUrl(WHATSAPP_GROUP_URL) || DEVELOPMENT_WHATSAPP_URL;
}
